import { getUserId } from "../component/Utils/Common";
import axios from "../AxiosInstance";

const fund_req_api = "ob/billing"
const reportsUrl = "/Reports"

class FundRequest {
    getPaymentNonJobNo(details) {
        return axios.post(fund_req_api + '/getPaymentNonJobNo', details);
    }
    getPaymentJobNo(details2) {
        return axios.post(fund_req_api + '/getPaymentJobNo', details2);
    }
    getFundStatus() {
        return axios.get(fund_req_api + '/getFundStatus');
    }
    getRequestPurpose() {
        return axios.get(fund_req_api + '/getRequestPurpose');
    }
    getBillPaymentType() {
        return axios.get(fund_req_api + '/getBillPaymentType');
    }
    getVendorType(requestStatus) {
        return axios.get(fund_req_api + '/getVendorType?requestStatus=' + requestStatus);
    }
    getPaymentReqPurpose(details) {
        return axios.post(fund_req_api + '/getPaymentReqPurpose', details)
    }
    getPaymentSummaryDetails(details) {
        return axios.post(fund_req_api + '/getPaymentSummaryDetails', details)
    }
    insertPaymentDetails(details) {
        return axios.post(fund_req_api + '/insertPaymentDetails', details)
    }
    updatePaymentDetails(details) {
        return axios.put(fund_req_api + '/updatePaymentDetails', details)
    }
    updatePaymentStatus(details) {
        return axios.put(fund_req_api + '/updatePaymentStatus', details)
    }
    insertPaymentStatus(details) {
        return axios.post(fund_req_api + '/insertPaymentStatus', details)
    }
    getPaymentDetails(details) {
        return axios.post(fund_req_api + '/getPaymentDetails', details)
    }
    getBalancePayment(payid) {
        return axios.get(fund_req_api + '/getBalancePayment?paymentId=' + payid);
    }
    getPaymentCopy(details) {
        return axios.post(fund_req_api + '/getPaymentCopy', details)
    }
    getVoucherType() {
        return axios.get(fund_req_api + '/getVoucherType');
    }
    getPrintedType() {
        return axios.get(fund_req_api + '/getPrintedType');
    }
    uploadPaymentCopy(details) {
        return axios.put(fund_req_api + '/uploadPaymentCopy', details)
    }
    uploadUTRTransaction(file) {
        let formData = new FormData();
        formData.append("file", file);
        return axios.post(reportsUrl + '/uploadUTRTransaction?createdBy=' + getUserId(), formData)
    }
    writeDispatchExcel(details) {
        return axios.post(reportsUrl + '/writeDispatchExcel', details)
    }
    ///fund audit
    getPaymentDetails_non_job_no_new(ip_consignmentId, status, ip_fundStatus) {
        return axios.get(fund_req_api + '/getPaymentDetails_non_job_no_new?ip_consignmentId=' + ip_consignmentId + '&status=' + status + '&ip_fundStatus=' + ip_fundStatus);
    }
    getPaymentDetails_Job_no_new(ip_consignmentId, status, ip_fundStatus) {
        return axios.get(fund_req_api + '/getPaymentDetails_Job_no_new?ip_consignmentId=' + ip_consignmentId + '&status=' + status + '&ip_fundStatus=' + ip_fundStatus);
    }
    get_a_payment_details_request_purpose_v1(ip_consignmentId, status, ip_fundStatus) {
        return axios.get(fund_req_api + '/get_a_payment_details_request_purpose_v1?ip_consignmentId=' + ip_consignmentId + '&status=' + status + '&ip_fundStatus=' + ip_fundStatus);
    }
    get_a_payment_summary_details(ip_consignmentId, ip_fundStatus) {
        return axios.get(fund_req_api + '/get_a_payment_summary_details?ip_consignmentId=' + ip_consignmentId + '&ip_fundStatus=' + ip_fundStatus);
    }
    get_o_ac_payment_estimated(ip_payments_id) {
        return axios.get(fund_req_api + '/get_o_ac_payment_estimated?ip_payments_id=' + ip_payments_id);
    }
    update_o_ac_payment_estimated(details) {
        return axios.put(fund_req_api + '/update_o_ac_payment_estimated', details)
    }
    update_a_payment_details_status_new_v1(details) {
        return axios.put(fund_req_api + '/update_a_payment_details_status_new_v1', details)
    }
    get_o_ac_payment_receipt_copy(payments_id) {
        return axios.get(fund_req_api + '/get_o_ac_payment_receipt_copy?payments_id=' + payments_id);
    }
    update_o_ac_payment_receipt_copy(details) {
        return axios.put(fund_req_api + '/update_o_ac_payment_receipt_copy', details)
    }
    getaccountdetailsbyId(accountId) {
        return axios.get(fund_req_api + '/getaccountdetailsbyId?accountId=' + accountId)
    }
    getaccountdetailbyId(accountId) {
        return axios.get(fund_req_api + '/getaccountdetailbyId?accountId=' + accountId)
    }
}
export default new FundRequest();